module.exports = function (app) {

	/**
	* @ngedoc ngController
	* @name pages.claimsAndSpending
	*
	* @requires $scope
	* @description
	* The pages.claimsAndSpending controller is a category level controller in Member Portal 
	* for the combined Claims & Spending page. 
	*/
	app.controller("pages.claimsAndSpending", ["services", "$scope", "aemContent", "sessionData", "coremetrics", "$state", "$sce", '$rootScope', '$cookies', 'manualHsaService', "brand",
		function (services, $scope, aemContent, sessionData, coremetrics, $state, $sce, $rootScope, $cookies, manualHsaService, brand) {
		$scope.headings = "Claims & Spending";
		$scope.sidebar.links = [];
		$scope.sidebar.data = {};
		$scope.sidebar.data.accumsFilter = 'activePlans';
		$scope.backText = 'Back';
		$scope.backAction = function() {
			$state.go('claimsAndSpending');
		}
		$scope.isVitalsActive = (brand.current.isVitalsActive) &&
			(sessionData && sessionData.appConfig && sessionData.appConfig.PROVIDER && sessionData.appConfig.PROVIDER.VITALS_LIVE && sessionData.appConfig.PROVIDER.VITALS_LIVE.booleanValue == true);

		$scope.showVitalsModal = function(){
			$scope.continueToDestination = function(){
                var targUrl = finderLogic.getSapphireSSOUrl(brand.current.sharedBrandCode);
                window.open(targUrl);
                $scope.closeModal();
			};
            $scope.siteToLeave = window.location.host.indexOf("mybenefitshome.com") !== -1 ?"Your health plan": "Highmark";
			modal.open({
				heading: "YOU WILL BE REDIRECTED TO SAPPHIRE DIGITAL",
				templateUrl: 'claims-and-spending.appTemplate.html/chmhom/modals/vitalsDisclaimerModal',
				scope:$scope
			});
		};

		// var coveredExpenses = teamsite.get("CLAIMS_AND_SPENDING_NAV_COVERED_EXPENSES");
		
		var portalSelectedPlan = services.rbsmbl.memberInfo().getPortalSelectedPlan();
		var hasSpendingAcct = portalSelectedPlan.spendingAccountExistsIndicator;

		if(hasSpendingAcct === "false" && !manualHsaService.shouldUserSeeHSAPage(sessionData.memberInfo)) {
			var hideSpending = true;
		}

		var payPremiumEnabledBrands = ['hmbcbs', 'hbs', 'hmbcbswv', 'hhic', 'fl', 'lou', 'az', 'neb', 'exc', 'regbcbs', 'regbs', 'wi', 'hz', 'inac', 'hmbcbsde', 'mn', 'pp', '6011','la'];
		var shouldGoToBilling = payPremiumEnabledBrands.indexOf(brand.current.sharedBrandCode) !== -1;
		var hidePayPremium = null;
		var directPay = sessionData.memberInfo.clientList[0].groupList[0].directPayIndicator;
		var medicare = sessionData.memberInfo.clientList[0].groupList[0].medicareIndicator;
		if(directPay === "true" || medicare === "true" && shouldGoToBilling){

			hidePayPremium = false;
		}
		else{
			hidePayPremium = true;
		}


		services.rbsmbl.ebillUserExists().getTargetUrl(brand).then(
			function (response) {
				if (response) {
					var unregistered = response &&
						response.data &&
						response.data.payload &&
						response.data.payload.ebillAccountexists === "N";
					if(unregistered){
						$scope.sidebar.links.push({
							"state": "ebill",
							"label": "Pay Health Plan Premium",
							"externalLink": "Yes",
							"newWindow": true,
							"hide": hidePayPremium,
							"heading": "Pay Premium",
							"description": "You can pay your plan premium"
						});
					}
					else{
						$scope.sidebar.links.push({
							"label": "Pay Health Plan Premium",
							"href": "/emssvc/x-services/secure/sso/outbound/auto/v1/vendor/EBILL?cm_sp=Ebill-_-Pay%20Monthly%20Premium-_-PAY%20MONTHLY%20PREMIUM",
							"externalLink": "Yes",
							"newWindow": true,
							"hide": hidePayPremium,
							"heading": "Pay Premium",
							"description": "You can pay your plan premium"
						});
					}
				}
			},
			function (err) {
				$scope.sidebar.links.push({
					"state": "ebill",
					"label": "Pay Health Plan Premium",
					"externalLink": "Yes",
					"newWindow": true,
					"hide": hidePayPremium,
					"heading": "Pay Premium",
					"description": "You can pay your plan premium"
				});
			}

		);

		$scope.sidebar.links.push({
			"state": "claimsAndSpending.spendingAccounts",
			"label": "Spending Accounts",
			"hide": hideSpending,
			"heading": "Review Your Plan Activity",
			"description": "View Your Claims, check account balances and see your progress towards your deductible"
		});

		$scope.sidebar.links.push({
			"state": "claimsAndSpending.claimsHistory",
			"label": "Claims History",
			"heading": "Review Your Claims",
			"description": "See your progress towards your deductible and review information about your claims by date, plans or other members on your plan.",
			"refineTemplate": 'claims-and-spending/claims-history.appTemplate.html/chmhom/pages/claims-and-spending/claims-history/refine',
			"refineController": "pages.claimsAndSpending.claimsHistory"
		});
		
		$scope.sidebar.links.push({
			"label": "Covered Expenses",
			"href": "https://tax.thomsonreuters.com/hcet-ebia/hmrk",
			"externalLink": "Yes",
			"newWindow": true,
			"coremetricsCategory": "MEMBER:CLAIMS AND SPENDING",
			"coremetricsElement": "COVERED EXPENSES"
		});

		 //if (brand.current.sharedBrandCode === "mincr" ||brand.current.sharedBrandCode === "wybcbs" || $state.current.name === "claimsAndSpending.healthPlans") {
		 //	$scope.sidebar.links.push({
		 //		"heading": '<span data-teamsite="MBR_Claims_LeftNav_HealthPlansHeadline"></span>',
		 //		"label": "Health Plans",
		 //		"state": "claimsAndSpending.healthPlans",
		 //		"description": '<span data-teamsite="MBR_Claims_LeftNav_HealthPlansHeadlineDesc"></span>',
		 //		//"refineTemplate": "pages/claims/healthPlansRefine.html",
			//	"refineTemplate": 'claims/healthPlans.appTemplate.html/chmhom/pages/claims/healthPlansRefine',
		 //		"refineController": "claims.claimsAndPaymentsRefine"
		 //	});
		 //}

		if (brand.current.sharedBrandCode === "mincr" ||brand.current.sharedBrandCode === "wybcbs" || $state.current.name === "claimsAndSpending.healthPlans") {
		$scope.sidebar.links.push({
			heading: '<span data-aem-content="MBR_Claims_LeftNav_HealthPlansHeadline"></span>',
			label: "Health Plans",
			description: '<span data-aem-content="MBR_Claims_LeftNav_HealthPlansHeadlineDesc"></span>',
			state: "claimsAndSpending.healthPlans",
			refineTemplate: 'claims/healthPlans.appTemplate.html/chmhom/pages/claims/healthPlansRefine',
			refineController: "claims.claimsAndPaymentsRefine"
			});
		}

		$scope.sidebar.links.push({
			"state": "claimsAndSpending.forms",
			"label": "Forms Library",
			"heading": "Find A Form",
			"description": "Find claim forms and other helpful resources.",
			"refineTemplate": 'claims-and-spending/claims-history.appTemplate.html/chmhom/pages/claims-and-spending/forms-library/forms-refine'
		});

		$scope.sidebar.links.push({
			"state": "claimsAndSpending.costSavingTools",
			"label": "Cost-Saving Tools",
			"heading": "Cost-Saving Tools",
			"description": "Find ways to save on your health care expenses."
		});

		$scope.sidebar.links.push({
			"state": "claimsAndSpending.messageCenter",
			"label": "Messages",
			"heading": "Claims & Benefits Messages",
			"description": "Review important messages about your health plan, eligibility for preventive care and more.",
			"refineTemplate": 'claims-and-spending/claims-history.appTemplate.html/chmhom/pages/claims-and-spending/message-center/casMessageCenterRefine'

		});

		$scope.sidebar.links.push({
			"state": "claimsAndSpending.statementArchive",
			"label": "Statement Archive",
			"heading": "Recent Claims Statements",
			"description": "Access health plan statements. The information here is as of 10/16/17.",
			"refineTemplate": 'claims-and-spending/claims-history.appTemplate.html/chmhom/pages/claims-and-spending/statement-archive/casStatementArchiveRefine'
		});

		$scope.sidebar.links.push({
			"state": "claimsAndSpending.educationalMaterial",
			"label": "Educational Material",
			"heading": "Review Available Educational Materials",
			"description": "You can review the educational documents and videos here to learn more about your claims section and EOBs.",
			"refineTemplate": 'claims-and-spending/claims-history.appTemplate.html/chmhom/pages/claims-and-spending/educational-material/casEducationalMaterialRefine'
		});

		$rootScope.$on('$stateChangeError', function (ev, to, toParams, from, fromParams) {
			if (to && to.name) {
				var cookieName = null;
				if (to.name === 'claims' || to.name.startsWith('claims.')) {
					cookieName = 'statePriorToClaims';
				} else if (to.name === 'spending' || to.name.startsWith('spending.')) {
					cookieName = 'statePriorToSpending';
				}

				if (cookieName !== null) {
					var priorState = $cookies.get(cookieName);
					if (priorState) {
						$cookies.remove(cookieName);
						$state.go(priorState);
					} else if (from && from.name && from.name !== "") {
						if (from.name.indexOf("claimsAndSpending") > -1) {
							window.location = "/mbr/#!/landing"
						} else {
							$cookies.put(cookieName, from.name);
						}
					}
				}
			}
        });
	}]);


	require('./claims-and-spending/spendingAccounts')(app);
	require('./claims-and-spending/hsaGroupSelection')(app);
	require("./claims-and-spending/claims-history/claimsHistory")(app);
	require("./claims-and-spending/sales-demo/salesDemo")(app);
	require("./claims-and-spending/cost-saving-tools/casCostSavingTools")(app);
	require("./claims-and-spending/educational-material/casEducationalMaterial")(app);
	require("./claims-and-spending/statement-archive/casStatementArchive")(app);
	require("./claims-and-spending/message-center/casMessageCenter")(app);
    require('./claims/healthPlans')(app);
    require('./claims/healthPlansRefine')(app);

	return [
		{
			state: "claimsAndSpending",
			postPassword: true,
			url: "/claims-and-spending",
			appConfigMaintenanceApp: "CLAIMS_AND_SPENDING",
			appConfigMaintenanceKey: "MAINTENANCE",
			views: {
				"body@": {
					"template": bootstrap.templates['page-templates/categoryCustom.html'],
					"controller": "pages.claimsAndSpending"
				},
				"content@claimsAndSpending": {
					templateUrl: 'claims-and-spending.appTemplate.html/chmhom/pages/claims-and-spending/spendingAccounts',
					"controller": "pages.claimsAndSpending.spendingAccounts"
				}
			},
			resolve: {
				claimsAndSpendingLogic:["services", "sessionData", "$q", "$state", "$window", "manualHsaService", "$cookies",
					function (services, sessionData, $q, $state, $window, manualHsaService, $cookies) {
					var deferred = $q.defer();
					var currentPlan = services.rbsmbl.memberInfo().getPortalSelectedPlan(sessionData.memberInfo);
					var salesDemoDD = $cookies.get('DDValue');
					var clientNumber = $cookies.get("mbrClientNumber");
					var theDate = new Date().getFullYear() + "-12-31";
					if (salesDemoDD) {
						deferred.resolve({"redirect": "claimsAndSpending.salesDemo"});
					} else {
						services.rbsmbl.vendorDetails().getVendorDetails(clientNumber, theDate, currentPlan.groupNumber).then(function (response) {
							var vendorDetails = (response
							&& response.data
							&& response.data.payload)
								? response.data.payload : [];
							for (var i=0; i < vendorDetails.length; i++) {
								if (vendorDetails[i].claimAndSpending) {
									if (currentPlan.spendingAccountExistsIndicator === "false"
										&& !manualHsaService.shouldUserSeeHSAPage(sessionData.memberInfo)) {
										deferred.resolve({"redirect": "claimsAndSpending.claimsHistory"});
									}
									deferred.resolve({"redirect": false});
								} else {
									$window.location = "/mbr/#!/landing";
									deferred.reject();
								}
							}
						}, function (error) {
							sessionData.vendorDetails = []
						});


					}
					//}else if (sessionData.isClaimsAndSpending) {
					//	if (currentPlan.spendingAccountExistsIndicator === "false" && !manualHsaService.shouldUserSeeHSAPage(sessionData.memberInfo)) {
					//		deferred.resolve({"redirect": "claimsAndSpending.claimsHistory"});
					//	}
					//	deferred.resolve({"redirect": false});
					// }else {
					// 	$window.location = "/member/landing";
					// 	deferred.reject();
					// }

					 return deferred.promise;
				}]
			}
		},
		{
			state: "claimsAndSpending.spendingAccounts",
			postPassword: true,
			url: "/spending-accounts",
			appConfigMaintenanceApp: "CLAIMS_AND_SPENDING",
			appConfigMaintenanceKey: "MAINTENANCE",
			views: {}
		},
		{
			state: "claimsAndSpending.hsaGroupSelection",
			postPassword: true,
			url: "/hsa-group-selection",
			appConfigMaintenanceApp: "CLAIMS_AND_SPENDING",
			appConfigMaintenanceKey: "MAINTENANCE",
			params: { hsaGroups: [] },
			views: {
				"body@": {
					"template": require('./claims-and-spending/page-templates/detailOneColumn.html'),
					"controller": "pages.claimsAndSpending"
				},
				"content@claimsAndSpending.hsaGroupSelection": {
					templateUrl: 'claims-and-spending/hsa-group-selection.appTemplate.html/chmhom/pages/claims-and-spending/hsaGroupSelection',
					"controller": "pages.claimsAndSpending.hsaGroupSelection"
				}
			}
		},
		{
			state: "claimsAndSpending.claimsHistory",
			postPassword: true,
			url: "/claims-history",
			appConfigMaintenanceApp: "CLAIMS_AND_SPENDING",
			appConfigMaintenanceKey: "MAINTENANCE",
			views: {
				"content@claimsAndSpending": {
					templateUrl: 'claims-and-spending/claims-history.appTemplate.html/chmhom/pages/claims-and-spending/claims-history/claimsHistory',
					controller: "pages.claimsAndSpending.claimsHistory"
				}
			}
		},
		{
			state: "claimsAndSpending.salesDemo",
			postPassword: true,
			url: "/sales-demo",
			appConfigMaintenanceApp: "CLAIMS_AND_SPENDING",
			appConfigMaintenanceKey: "MAINTENANCE",
			views: {
				"content@claimsAndSpending": {
					template: require("./claims-and-spending/sales-demo/salesDemo.html"),
					controller: "pages.claimsAndSpending.salesDemo"
				}
			}
		},
		{
			state: "claimsAndSpending.forms",
			postPassword: true,
			url: "/forms",
			    resolve: {
                resourcesList: ["contentResourceServices", function(contentResourceServices){
                    return contentResourceServices.getResourceIdListAsync();
                }]
            },
            views: {
                "body@": {
                    template: bootstrap.templates["page-templates/category.html"],
                    controller: "pages.claimsAndSpending"
                },
                "content@claimsAndSpending.forms": {
					template: "<div></div>",
					controller: ['$window',function($window){
						$window.location = "/member/forms";
					}]
                }
            }
        },
        {
        state: "claimsAndSpending.costSavingTools",
			postPassword: true,
			url: "/cost-saving-tools",
			resolve: {
				 resourcesList: ["contentResourceServices", function(contentResourceServices){
                    return contentResourceServices.getResourceIdListAsync();
                }]
			},
		views: {
                "body@": {
                    template: bootstrap.templates["page-templates/category.html"],
                    controller: "pages.claimsAndSpending"
                },
                "content@claimsAndSpending.costSavingTools": {
					templateUrl: 'claims-and-spending/cost-saving-tools.appTemplate.html/chmhom/pages/claims-and-spending/cost-saving-tools/casCostSavingTools',
                    controller: "pages.claimsAndSpending.casCostSavingTools"
                }
            }
        },
        {
			state: 'claimsAndSpending.messageCenter',
            appConfigMaintenanceApp: 'CLAIMS',
            appConfigMaintenanceKey: 'MESSAGE_CENTER_MAINTENANCE',
			url: '/messageCenter?filterType',
            params: { id: '' },
			views: {
				'content@claimsAndSpending': {
					templateUrl: 'claims-and-spending/messageCenter.appTemplate.html/chmhom/pages/claims-and-spending/message-center/casMessageCenter',
					controller: 'pages.claimsAndSpending.casMessageCenter'
				},
                'rightColumn@claims': {}
			}
		},
		 {
			state: 'claimsAndSpending.statementArchive',
            appConfigMaintenanceApp: 'CLAIMS',
            appConfigMaintenanceKey: 'STATEMENT_ARCHIVE_MAINTENANCE',
			url: '/statementArchives',
			views: {
				'content@claimsAndSpending': {
					templateUrl: 'claims-and-spending/statementArchives.appTemplate.html/chmhom/pages/claims-and-spending/statement-archive/casStatementArchive',
					controller: 'pages.claimsAndSpending.casStatementArchive'
				},
                'rightColumn@claims': {}
			}
		},
		 {
			state: 'claimsAndSpending.educationalMaterial',
            appConfigMaintenanceApp: 'CLAIMS',
            appConfigMaintenanceKey: 'EDUCATIONAL_MATERIAL_MAINTENANCE',
			url: '/educational-materials',
            resolve: {
                resourcesList: ["contentResourceServices", function(contentResourceServices){
					var CONTENT_TYPE = "Bluecore Resources";
                    return contentResourceServices.getResourceIdListAsync(CONTENT_TYPE);
                }]
            },
			views: {
				'content@claimsAndSpending': {
					templateUrl: 'claims-and-spending/educational-materials.appTemplate.html/chmhom/pages/claims-and-spending/educational-material/casEducationalMaterial',
					controller: 'pages.claimsAndSpending.casEducationalMaterial'
				},
                'rightColumn@claims': {}
			}
		},
		{
            state: 'claimsAndSpending.healthPlans',
            appConfigMaintenanceApp: 'CLAIMS',
            appConfigMaintenanceKey: 'HEALTH_PLANS_MAINTENANCE',
            url: '/healthPlans',
            views: {
                'content@claimsAndSpending': {
					templateUrl: 'claims-and-spending/healthPlans.appTemplate.html/chmhom/pages/claims/healthPlans',
                    controller: 'pages.claims.healthPlans'
                }
                //"rightColumn@claimsAndSpending": {
					//templateUrl: 'claims-and-spending/healthPlans.appTemplate.html/chmhom/pages/claims/rightSidebar',
                //    controller: "pages.claimsAndSpending"
                //}
            }
        },
		{
			state: 'ebill',
			url: '/ebill'
		}
	];
};